module.exports = __webpack_public_path__ + "static/media/mailnews_17.d018fda2.ico";